import axios from "axios";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";

export default function StepperControl({handleClick, currentStep, steps}) {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");

    let productName
    let productType
    let productCategory
    let productImage
    let productImageName

    let [addedDps, setAddedDps] = useState([]);

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            //console.log(error.message);
        }
    }

    async function addProductDp(productId) {
        //console.log(sessionStorage.getItem("addedDps"))
        if (sessionStorage.getItem("newDpAddition") === "" || sessionStorage.getItem("newDpAddition") === null) {
            //console.log(JSON.parse(sessionStorage.getItem("addedDps")))
            setErrorMessage("No changes done. There is nothing to be saved..")
        } else {
            setErrorMessage("")
            let productCatalogInfo = {
                productId: productId, dpIds: JSON.parse(sessionStorage.getItem("newDpAddition"))
            }


            //console.log(pid)
            var url = CROMPTON_URL + "product/add/productDpInfos"
            axios({
                method: 'post',
                url: url,
                data: productCatalogInfo,
                headers: {
                    Authorization: decryptedValue,
                }

            }).then(response => {
                sessionStorage.removeItem("newDpAddition")
                //console.log(response)
                navigate("/admin/products/products-overview")
                //window.location.reload()
            })
                .catch(
                    error => {
                        setErrorMessage("Error adding data points")
                        navigate("/admin/products/products-overview")

                        //setErrorMessage(error.response.data.message)
                       //console.log(error);
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })
        }


    }

    function handleFirstStepClick() {
        productName = sessionStorage.getItem("newProduct-productName")
        productType = sessionStorage.getItem("newProduct-productType")
        productCategory = sessionStorage.getItem("newProduct-productCategory")

        if (productName === "" || productName === null || productType === "" || productType === null || productCategory === "" || productCategory === null) {
            setErrorMessage("Please fill all the fields....")
        } else {
            setErrorMessage("")
            handleClick("next")
        }
    }

    function handleSubmitProductCreation() {
        //console.log("Inisded")
        productName = sessionStorage.getItem("newProduct-productName")
        productType = sessionStorage.getItem("newProduct-productType")
        productCategory = sessionStorage.getItem("newProduct-productCategory")
        productImage = sessionStorage.getItem("updatedProductImage")
        productImageName = sessionStorage.getItem("uploadedImageFilename")
        addedDps = JSON.parse(sessionStorage.getItem("newDpAddition"))


        //console.log(productImage)
        //console.log(productImageName)

        let bodyFormData;
        bodyFormData = {
            mfg: 0,
            categoryEnUrl: "",
            productUrl: "",
            categoryUrl: "",
            unit: productCategory,
            category: productType,
            product: productName
        }

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'product/create',
            data: bodyFormData,
            headers: {
                Authorization: decryptedValue,
            }

            // 1 0 0    1 0 1  1 1 0  1 1 1

        }).then(response => {
            //console.log(response)
            if (response.status === 200) {
                sessionStorage.removeItem("newProduct-productName")
                sessionStorage.removeItem("newProduct-productCategory")
                sessionStorage.removeItem("newProduct-productType")
                //100
                if (((sessionStorage.getItem("uploadedImageFilename") === "" || sessionStorage.getItem("uploadedImageFilename") === null) && (JSON.parse(sessionStorage.getItem("newDpAddition")) === "" || JSON.parse(sessionStorage.getItem("newDpAddition")) === null || JSON.parse(sessionStorage.getItem("newDpAddition")) === undefined)) === true) {
                   // console.log("1")
                    navigate("/admin/products/products-overview")
                } else if((JSON.parse(sessionStorage.getItem("newDpAddition")) === "" || JSON.parse(sessionStorage.getItem("newDpAddition")) === null) || (sessionStorage.getItem("uploadedImageFilename") === "" || sessionStorage.getItem("uploadedImageFilename") === null)){
                    if(JSON.parse(sessionStorage.getItem("newDpAddition")) === "" || JSON.parse(sessionStorage.getItem("newDpAddition")) === null){
                        //110
                       // console.log("1")
                        updateProductInformation(response.data.productId, productName, productType, productCategory)
                    }else{
                       // console.log("1")
                        //101
                        addProductDp(response.data.productId)
                    }

                }else{
                    //console.log("1")

                    updateProductInformationV2(response.data.productId, productName, productType, productCategory)
                }
                //console.log("Inside")

            } else {
                setErrorMessage(response.data.message)
            }
        })
            .catch(error => {
                //console.log(error)
                setErrorMessage(error.message)
            })
    }

    async function updateProductInformation(productId, productName, productType, productCategory) {
        let productCatalogInfo = {
            productId: productId, product: productName, mfg: 0, unit: productType, category: productCategory
        }

        //console.log("Updated Product Info Image:", updatedProductInfoImage)
        const bodyFormData = new FormData();
        //let blob

        const json = JSON.stringify(productCatalogInfo);
        const jsonBlob = new Blob([json], {
            type: 'application/json'
        });

        const byteString = atob(productImage.split(',')[1]); // Strip off the data URL header
        const mimeString = productImage.split(',')[0].split(':')[1].split(';')[0];
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }

        const file = new File([arrayBuffer], 'uploaded_image', {type: mimeString});

        bodyFormData.append("productCatalogInfo", jsonBlob)
        bodyFormData.append("fileImage", file);

        //console.log(pid)
        var url = CROMPTON_URL + "product/update/productImage/" + productId
        await axios.post(url, bodyFormData, {
            headers: {
                "Content-Type": "multipart/form-data", Authorization: decryptedValue
            },
        }).then((response) => {
            sessionStorage.removeItem("uploadedImageFileName")
            sessionStorage.removeItem("uploadedImageFile")
            sessionStorage.removeItem("updatedProductImage")
            sessionStorage.removeItem("updatedProductImageName")
            setErrorMessage("Successful")
            navigate("/admin/products/products-overview")
        }).catch((error) => {
            setErrorMessage("Product is created but encountered error while uploading image")
            sessionStorage.removeItem("uploadedImageFileName")
            sessionStorage.removeItem("uploadedImageFile")
            sessionStorage.removeItem("updatedProductImage")
            sessionStorage.removeItem("updatedProductImageName")
            navigate("/admin/products/products-overview")
            //setErrorMessage(error.response.data.message)
           // console.log(error);
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })


    }

    async function updateProductInformationV2(productId, productName, productType, productCategory) {
        let productCatalogInfo = {
            productId: productId, product: productName, mfg: 0, unit: productType, category: productCategory
        }

        //console.log("Updated Product Info Image:", updatedProductInfoImage)
        const bodyFormData = new FormData();
        //let blob

        const json = JSON.stringify(productCatalogInfo);
        const jsonBlob = new Blob([json], {
            type: 'application/json'
        });

        const byteString = atob(productImage.split(',')[1]); // Strip off the data URL header
        const mimeString = productImage.split(',')[0].split(':')[1].split(';')[0];
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }

        const file = new File([arrayBuffer], 'uploaded_image', {type: mimeString});

        bodyFormData.append("productCatalogInfo", jsonBlob)
        bodyFormData.append("fileImage", file);

        //console.log(pid)
        var url = CROMPTON_URL + "product/update/productImage/" + productId
        await axios.post(url, bodyFormData, {
            headers: {
                "Content-Type": "multipart/form-data", Authorization: decryptedValue
            },
        }).then((response) => {
            sessionStorage.removeItem("uploadedImageFileName")
            sessionStorage.removeItem("uploadedImageFile")
            sessionStorage.removeItem("updatedProductImage")
            sessionStorage.removeItem("updatedProductImageName")
            setErrorMessage("Successful")
            addProductDp(productId)
            //navigate("/senze-2.0/admin/products/products-overview")
        }).catch((error) => {
            sessionStorage.removeItem("uploadedImageFileName")
            sessionStorage.removeItem("uploadedImageFile")
            sessionStorage.removeItem("updatedProductImage")
            sessionStorage.removeItem("updatedProductImageName")
            setErrorMessage("Product is created but encountered error while uploading image")
            navigate("/admin/products/products-overview")
            //setErrorMessage(error.response.data.message)
            //console.log(error);
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })


    }


    return (
        <div>
            <div className="mt-5 flex flex-col justify-between px-3 pt-2 md:flex-row md:px-8">
                {currentStep === steps.length - 2 ? (
                    <div/>
                ) : (
                    <button
                        onClick={() => handleClick()}
                        className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mb-0`}
                    >
                        Prev
                    </button>
                )}

                <button
                    onClick={() => (currentStep === steps.length ? handleSubmitProductCreation() : currentStep === 1 ? handleFirstStepClick() : handleClick("next"))}
                    className="cursor-pointer rounded-xl bg-[#004c86] px-16 py-2 font-medium text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:hover:bg-[#004c86] dark:active:opacity-90 md:ml-2">
                    {currentStep === steps.length ? "Submit" : "Next"}
                </button>
            </div>
            <div>
                <span className="errorMessage items-center flex justify-content: center align-items: center flex-col">
                    {errorMessage}
                </span>
            </div>
        </div>


    );
}
